import { ParentTypes } from '@risksmart-app/domain/src/types/consts';
import i18n from '@risksmart-app/i18n/src/i18n';

import { t } from '../../i18n-t';
import { getAuditColumns } from './shared';
import type { SharedDataset } from './types';

export const getEntities = () =>
  ({
    hasAccess: (isModuleEnabled, isFeatureFlagEnabled) =>
      isFeatureFlagEnabled('cds_enterprise_risk') &&
      isModuleEnabled('enterprise_risk'),
    objectType: ParentTypes.Entity,
    label: i18n.format(t('entity_other'), 'capitalize'),
    datasetRelationshipOverrides: {
      entities: ['parent', 'child'],
      // `entity` is a leaf in the object hierarchy tree, so the derived
      // relationship falls back to `sibling` and the query builder joins via
      // `linked_item` — which never holds entity rows. The real linkage lives
      // in `enterprise_risk_instance`, reached through the `risks` dataset's
      // `parentJoinPaths` (CUS-269).
      risks: ['child'],
    },
    fields: {
      id: {
        dataType: 'guid',
        displayType: 'text',
        defaultLabel: t('columns.guid'),
      },
      name: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: t('entity.columns.name'),
      },
      description: {
        dataType: 'text',
        displayType: 'text',
        defaultLabel: t('entity.columns.description'),
      },
      weight: {
        dataType: 'number',
        displayType: 'number',
        defaultLabel: t('entity.columns.weight'),
      },
      ...getAuditColumns(),
    },
  }) as const satisfies SharedDataset;
